import uniqueId from 'lodash/uniqueId'
import { BRAND_CONFIG } from '../branding/brandConfig'
import { DEFAULT_BRAND_THEME } from './brandTheme'

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export function getStoredBrandProfiles() {
  if (!canUseStorage()) return []

  try {
    const raw = window.localStorage.getItem(BRAND_CONFIG.storage.profileKey)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (error) {
    return []
  }
}

export function saveStoredBrandProfiles(profiles) {
  if (!canUseStorage()) return
  window.localStorage.setItem(
    BRAND_CONFIG.storage.profileKey,
    JSON.stringify(profiles)
  )
}

export function upsertBrandProfile(profile, existingProfiles = []) {
  const nextProfile = {
    ...profile,
    id: profile?.id || uniqueId('brand_profile_'),
  }

  const filtered = existingProfiles.filter((item) => item.id !== nextProfile.id)
  return [...filtered, nextProfile]
}

export function removeBrandProfile(profileId, existingProfiles = []) {
  return existingProfiles.filter((item) => item.id !== profileId)
}

export function applyBrandProfileToTheme(profile, currentTheme = DEFAULT_BRAND_THEME) {
  if (!profile?.theme) {
    return { ...DEFAULT_BRAND_THEME, ...currentTheme }
  }

  return {
    ...DEFAULT_BRAND_THEME,
    ...currentTheme,
    ...profile.theme,
    palette: profile.palette?.length ? profile.palette : null,
    title: currentTheme?.title ?? '',
    subtitle: currentTheme?.subtitle ?? '',
  }
}
